import React, { useEffect, useState } from 'react'
import banner from "../assets/images/banner.png"
import banner2 from "../assets/images/strong mobile-min.png"
import bannerIcon1 from "../assets/images/bannerLogo1.png"
import bannerIcon2 from "../assets/images/bannerLogo2.png"
import bannerIcon3 from "../assets/images/bannerLogo3.png"
import bannerIcon4 from "../assets/images/bannerLogo4.png"
import 'aos/dist/aos.css';

const Banner = () => {
  
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      
      window.addEventListener('resize', handleResize);
      
      // Initial check
      handleResize();
      
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  

  return (
    <div className="bannerContainer">

      {isMobile? <img src={banner2} alt="banner img" className="bannerImage" loading="lazy"/> : <img src={banner} alt="banner img" className="bannerImage" loading="lazy"/>}
      
      <div className="bannerContent">
        <h1 data-aos="fade-up"
     data-aos-duration="2000">کنار هم، قـوی‌تریم</h1>
        <p data-aos="fade-up"
     data-aos-duration="2000">کمپرسور اینورتر دیجیتال با قابلیت انجماد سریع مواد غذایی</p>
        <p className="content" data-aos="fade-up"
     data-aos-duration="2000">
        یخچال‌های مجهز به کمپرسور اینورتر دیجیتال به عنوان دستگاه‌های "کم مصرف" و "بهینه در مصرف انرژی" شناخته می‌شوند. برخلاف کمپرسورهای قدیمی که به طور ناگهانی روشن و خاموش می‌شوند، کمپرسور اینورتر دیجیتال با تکنولوژی تنظیم سرعت، دمای داخلی یخچال را به‌طور یکنواخت و پایدار نگه می‌دارد و قادر به ایجاد سرعت سریع انجماد برای موادغذایی است که باعث می‌شود نوسانات دمایی کاهش یافته و موادغذایی برای مدت طولانی‌تری در یخچال تازه بماند.        </p> 
        <div className="bannerCats">
        <img src={bannerIcon1} alt="banner icon 1" loading="lazy"/>
        <img src={bannerIcon2} alt="banner icon 2" loading="lazy"/>
        <img src={bannerIcon3} alt="banner icon 3" loading="lazy"/>
        <img src={bannerIcon4} alt="banner icon 4" loading="lazy"/>
      </div>
      </div>
     
    </div>
  )
}

export default Banner